import axios from '../axios';

export default {
  load ({ abonentId }) {
    return new Promise((resolve, reject) => {
      axios.get(`/face-person?filter[abonent_id]=${abonentId}`)
        .then(response => {
          if (response.data.errors && response.data.errors.length > 0) {
            reject(response.data.errors);
          } else {
            resolve(response.data);
          }
        })
        .catch(err => reject(err));
    });
  },

  createFacePerson ({ abonentId, name }) {
    return new Promise((resolve, reject) => {
      axios.post(`/abonent/${abonentId}/face-person`, {
        name,
      })
        .then(response => {
          if (response.data.errors && response.data.errors.length > 0) {
            reject(response.data.errors);
          } else {
            resolve(response.data);
          }
        })
        .catch(err => reject(err));
    });
  },

  deletePhoto ({ id }) {
    return new Promise((resolve, reject) => {
      axios.delete(`/face-person-photo/${id}`)
        .then(response => {
          if (response.data.errors && response.data.errors.length > 0) {
            reject(response.data.errors);
          } else {
            resolve(response.data);
          }
        })
        .catch(err => reject(err));
    });
  },

  uploadPhoto ({ req }) {
    return new Promise((resolve, reject) => {
      axios.post('/face-person-photo', req)
        .then(response => {
          if (response.data.errors && response.data.errors.length > 0) {
            reject(response.data.errors);
          } else {
            resolve(response.data);
          }
        })
        .catch(err => reject(err));
    });
  },
};
